<template>
  <main class="main page-inside payment-result-page">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper">
          <div class="title big">Thank you for your purchase! You will receive all skins files to your provided e-mail. In case of any questions, please contact us at support@{{$parent.hostname}}</div>
        </div>
      </div>
    </div>
    <footer class="new-footer">
      <div class="footer-top">
        <div class="wrapper">
          <div class="footer-links">
            <a 
              v-for="page in footerPages" 
              :key="page.id"
              @click="$parent.goToPage(page)" 
              class="footer-link"
            >
              {{ page.title.toUpperCase() }}
            </a>
          </div>
        </div>
      </div>
      <div class="footer-middle">
        <div class="wrapper">
          <div class="footer-column footer-column-left">
            <div class="footer-info">
              <div class="footer-info" v-if="$parent.settings">
                <div class="footer-info-item" v-if="$parent.settings.company_name"><span class="footer-info-label">COMPANY NAME:</span> {{ $parent.settings.company_name }}</div>
                <div class="footer-info-item" v-if="$parent.settings.company_reg_number"><span class="footer-info-label">REGISTRATION NUMBER:</span> {{ $parent.settings.company_reg_number }}</div>
                <div class="footer-info-item" v-if="$parent.settings.company_address"><span class="footer-info-label">ADDRESS:</span> {{ $parent.settings.company_address }}</div>
              </div>
            </div>
          </div>
          <div class="footer-column footer-column-center">
            <router-link to="/" class="footer-logo">
              <img src="../img/footer logo.svg" class="footer-logo-img" />
            </router-link>
          </div>
          <div class="footer-column footer-column-right">
            <div class="footer-support">
              <div class="footer-support-email" v-if="$parent.settings && $parent.settings.support_email">SUPPORT: {{ $parent.settings.support_email }}</div>
              <div class="footer-social-icons">
                <a
                  v-for="link in $parent.socials"
                  :key="link.image"
                  :href="link.link"
                  target="_blank"
                  class="footer-social-icon"
                >
                  <img 
                    :src="getSocialIcon(link.link)" 
                    :alt="link.link" 
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-bottom">
        <div class="wrapper">
          <div class="footer-copyright" v-if="$parent.settings && $parent.settings.copyright">
            {{ $parent.settings.copyright }}
          </div>
          <div class="footer-payment-methods">
            <img src="../img/Mastercard.svg" class="payment-icon" alt="Mastercard" />
            <img src="../img/visa-pay.svg" class="payment-icon" alt="Visa" />
            <img src="../img/apple-pay.svg" class="payment-icon" alt="Apple Pay" />
            <img src="../img/google-pay.svg" class="payment-icon" alt="Google Pay" />
          </div>
        </div>
      </div>
    </footer>
  </main>
</template>
<script>
import acebookIcon from '../img/acebook.svg';
import instagramIcon from '../img/instagram.svg';
import steamIcon from '../img/steam.svg';

export default {
  name: 'PaymentSuccessPage',
  props: [],
  components: {
  },
  data: function() {
    return {
      acebookIcon: acebookIcon,
      instagramIcon: instagramIcon,
      steamIcon: steamIcon
    }
  },
  computed: {
    footerPages() {
      if (!this.$parent.textPageList || !Array.isArray(this.$parent.textPageList)) {
        return [];
      }
      const keywords = ['terms', 'privacy', 'cookie'];
      return keywords
        .map(keyword => {
          return this.$parent.textPageList.find(page => 
            page.slug && page.slug.toLowerCase().includes(keyword) ||
            page.title && page.title.toLowerCase().includes(keyword)
          );
        })
        .filter(page => page !== undefined);
    }
  },
  methods: {
    getSocialIcon(link) {
      if (!link) return '';
      const linkLower = link.toLowerCase();
      
      if (linkLower.includes('facebook') || linkLower.includes('fb')) {
        return this.acebookIcon;
      }
      if (linkLower.includes('instagram')) {
        return this.instagramIcon;
      }
      if (linkLower.includes('steam')) {
        return this.steamIcon;
      }
      return this.acebookIcon;
    },
    isFacebookLink(link) {
      return link && (link.toLowerCase().includes('facebook') || link.toLowerCase().includes('fb'));
    }
  }
}
</script>